import { envConfig } from "@configs/env";
import { _MemberSettingOnboardDialogLayout, DeployEnv } from "@types";
import {
  MemberFundingProfileSettings,
  MemberSettingDepositMethodGrouping,
  MemberSettingFundingMode,
  MemberSettingNameMode,
  MemberSettingPlayerNameCollectionMode,
} from "kz-ui-sdk";

type FundingProfileBankConfig = MemberFundingProfileSettings["supportedTypes"]["bank"] | null;
type FundingProfileEwalletConfig = MemberFundingProfileSettings["supportedTypes"]["e-wallet"] | null;

export const DEV_FLAG_KEYs = {
  NOTIFICATION_DRAWER_ENABLED_DEV: "NOTIFICATION_DRAWER_ENABLED_DEV",
  DIALOG_LAYOUT_DEV: "DIALOG_LAYOUT_DEV",
  DEPOSIT_MODE_DEV: "DEPOSIT_MODE_DEV",
  NAME_MODE_DEV: "NAME_MODE_DEV",
  FUNDING_MODE_DEV: "FUNDING_MODE_DEV",
  LANGUAGE_LIST_DEV: "LANGUAGE_LIST_DEV",
  OTP_TYPE_DEV: "OTP_TYPE_DEV",
  ENABLE_MAINTENANCE_MODE_DEV: "ENABLE_MAINTENANCE_MODE_DEV",
  DISABLE_MAINTENANCE_REDIRECT_DEV: "DISABLE_MAINTENANCE_REDIRECT_DEV",
  DESKTOP_BLOCKER_DEV: "DESKTOP_BLOCKER_DEV",
  BANK_CONFIG_DEV: "BANK_CONFIG_DEV",
  EWALLET_CONFIG_DEV: "EWALLET_CONFIG_DEV",
  NAME_COLLECTION_MODE_DEV: "NAME_COLLECTION_MODE_DEV",
  ENABLE_SENTRY_DEV: "ENABLE_SENTRY_DEV",
  DEV_LOG_DEV: "DEV_LOG_DEV",
  DEV_LOG_TAG_DEV: "DEV_LOG_TAG_DEV",
};

/**
 * Get dev flags from localStorage
 * Turn off dev flags in production
 */
export const getDevFlags = () => {
  if (envConfig.deploymentEnv === DeployEnv.Production) {
    return null;
  }

  const notificationDrawerEnabled = localStorage.getItem(DEV_FLAG_KEYs.NOTIFICATION_DRAWER_ENABLED_DEV) ?? null;

  return {
    dialogLayout: localStorage.getItem(DEV_FLAG_KEYs.DIALOG_LAYOUT_DEV) as _MemberSettingOnboardDialogLayout | null,
    depositMode: localStorage.getItem(DEV_FLAG_KEYs.DEPOSIT_MODE_DEV) as MemberSettingDepositMethodGrouping | null,
    nameMode: localStorage.getItem(DEV_FLAG_KEYs.NAME_MODE_DEV) as MemberSettingNameMode | null,
    fundingMode: localStorage.getItem(DEV_FLAG_KEYs.FUNDING_MODE_DEV) as MemberSettingFundingMode | null,
    languageList: localStorage.getItem(DEV_FLAG_KEYs.LANGUAGE_LIST_DEV) as string,
    otpType: localStorage.getItem(DEV_FLAG_KEYs.OTP_TYPE_DEV) as "SMS" | "Email" | "WhatsApp" | null,
    enableMaintenanceMode: localStorage.getItem(DEV_FLAG_KEYs.ENABLE_MAINTENANCE_MODE_DEV) === "true",
    disableMaintenanceRedirect: localStorage.getItem(DEV_FLAG_KEYs.DISABLE_MAINTENANCE_REDIRECT_DEV) === "true",
    desktopBlocker: localStorage.getItem(DEV_FLAG_KEYs.DESKTOP_BLOCKER_DEV) === "true",
    bankConfig: (localStorage.getItem(DEV_FLAG_KEYs.BANK_CONFIG_DEV)
      ? (JSON.parse(localStorage.getItem(DEV_FLAG_KEYs.BANK_CONFIG_DEV) ?? "{}") as FundingProfileBankConfig)
      : null) as FundingProfileBankConfig,
    ewalletConfig: (localStorage.getItem(DEV_FLAG_KEYs.EWALLET_CONFIG_DEV)
      ? (JSON.parse(localStorage.getItem(DEV_FLAG_KEYs.EWALLET_CONFIG_DEV) ?? "{}") as FundingProfileEwalletConfig)
      : null) as FundingProfileEwalletConfig,
    nameCollectionMode: localStorage.getItem(
      DEV_FLAG_KEYs.NAME_COLLECTION_MODE_DEV,
    ) as MemberSettingPlayerNameCollectionMode | null,
    notificationDrawerEnabled: notificationDrawerEnabled === null ? null : notificationDrawerEnabled === "true",
    enableSentry: localStorage.getItem(DEV_FLAG_KEYs.ENABLE_SENTRY_DEV) === "true",
    devLog: localStorage.getItem(DEV_FLAG_KEYs.DEV_LOG_DEV) === "true",
    devLogTag: (localStorage.getItem(DEV_FLAG_KEYs.DEV_LOG_TAG_DEV) ?? "").split(","),
  };
};
